import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const AdminPanel = () => {
  const [nepotrjeni, setNepotrjeni] = useState([]);

  const fetchNepotrjeni = async () => {
    try {
      const res = await axios.get("https://fnm-backend.aibc-robotics.com/admin/nepotrjeni-uporabniki");
      setNepotrjeni(res.data);
    } catch (err) {
      console.error("Napaka pri pridobivanju nepotrjenih:", err);
      toast.error("Napaka pri pridobivanju uporabnikov.");
    }
  };

  const potrdiUporabnika = async (userId) => {
    try {
      await axios.put(`https://fnm-backend.aibc-robotics.com/admin/potrdi-uporabnika/${userId}`);
      toast.success("Uporabnik potrjen!");
      setNepotrjeni((prev) => prev.filter((u) => u.id !== userId));
    } catch (err) {
      console.error("Napaka pri potrditvi:", err);
      toast.error("Napaka pri potrditvi.");
    }
  };

  const zavrniUporabnika = async (userId) => {
    try {
      await axios.delete(`https://fnm-backend.aibc-robotics.com/admin/zavrni-uporabnika/${userId}`);
      toast.success("Uporabnik zavrnjen!");
      setNepotrjeni((prev) => prev.filter((u) => u.id !== userId));
    } catch (err) {
      console.error("Napaka pri zavrnitvi:", err);
      toast.error("Napaka pri zavrnitvi.");
    }
  };

  useEffect(() => {
    fetchNepotrjeni();
  }, []);

  return (
    <div className="bg-white mt-8 p-6 rounded-xl shadow-lg w-full max-w-3xl">
      <h3 className="text-lg font-bold mb-4 text-blue-700">Nepotrjeni uporabniki</h3>
      {nepotrjeni.length === 0 ? (
        <p className="text-gray-500">Ni nepotrjenih uporabnikov.</p>
      ) : (
        <ul className="space-y-2">
          {nepotrjeni.map((user) => (
            <li
              key={user.id}
              className="flex justify-between items-center p-3 bg-gray-50 border rounded-md"
            >
              <div>
                <p className="font-semibold">{user.ime} {user.priimek}</p>
                <p className="text-sm text-gray-600">{user.email}</p>
              </div>
              <div className="space-x-2">
                <button
                  onClick={() => potrdiUporabnika(user.id)}
                  className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
                >
                  Potrdi
                </button>
                <button
                  onClick={() => zavrniUporabnika(user.id)}
                  className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                >
                  Zavrni
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdminPanel;
